export default {
  category_name: 'Cumpără card cadou',
};
